import React, { Component } from "react";
import { connect } from "react-redux";
import { withFirebase } from "../../firebase";
import { updateFirebaseConfig, updateLogin } from "../../reducers/auth";
import Auth from "./auth";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import * as ROUTES from "../../constants/routes";
import { AuthUserContext } from "../../sessions";

class AuthContainer extends Component {
	constructor() {
		super();
		this.state = {
			loadStatus: false,
		};
	}
	signIn = async (data) => {
		this.signInAttemptId = (this.signInAttemptId || 0) + 1;
		const attemptId = this.signInAttemptId;

		const withTimeout = (promise, ms) => {
			let timeoutId;
			const timeoutPromise = new Promise((_, reject) => {
				timeoutId = setTimeout(() => reject(new Error("timeout")), ms);
			});

			return Promise.race([promise, timeoutPromise]).finally(() => {
				clearTimeout(timeoutId);
			});
		};

		this.setState({
			loadStatus: true,
		});

		try {
			if (this.props.firebase && this.props.firebase.ensureAppCheckToken) {
				await withTimeout(this.props.firebase.ensureAppCheckToken(), 3000);
			}
		} catch (e) {}

		const signInOnce = () => {
			if (!this.props.firebase) {
				return Promise.reject(new Error("firebase-not-ready"));
			}

			return this.props.firebase.doSignInWithEmailAndPassword(
				data.email,
				data.password
			);
		};

		const onSuccess = () => {
			if (attemptId !== this.signInAttemptId) return;

			const login = localStorage.getItem("@login");
			if (login) {
				this.props.updateLogin(login);
			}

			this.props.history.push(ROUTES.DEFAULT);
			this.setState({ loadStatus: false });
		};

		const onFail = () => {
			if (attemptId !== this.signInAttemptId) return;
			alert("Возможно не правильные данные для входа! Попробуйте еще раз!");
			this.setState({ loadStatus: false });
		};

		try {
			await withTimeout(signInOnce(), 15000);
			onSuccess();
		} catch (error) {
			const errorCode =
				error && typeof error.code === "string" ? error.code : "";
			const errorMessage =
				error && typeof error.message === "string" ? error.message : "";
			const shouldRetry =
				errorCode === "auth/invalid-app-credential" ||
				errorCode === "auth/network-request-failed" ||
				/app\s?check/i.test(errorMessage) ||
				(error && error.message === "timeout");

			if (!shouldRetry) {
				onFail();
				return;
			}

			try {
				if (this.props.firebase && this.props.firebase.ensureAppCheckToken) {
					await withTimeout(this.props.firebase.ensureAppCheckToken(), 3000);
				}
			} catch (e) {}

			try {
				await withTimeout(signInOnce(), 15000);
				onSuccess();
			} catch (e) {
				onFail();
			}
		}
	};

	signOut = async () => {
		this.props.history.push(ROUTES.SIGN_IN);

		try {
			if (this.props.firebase && this.props.firebase.doSignOut) {
				await this.props.firebase.doSignOut();
			}
		} catch (e) {}

		localStorage.removeItem("@login");
		localStorage.removeItem("adminPermission");
		localStorage.removeItem("chosenCity");
		localStorage.removeItem("chosenBrand");
		localStorage.removeItem("currentBrand");
		localStorage.removeItem("currentCity");
		this.props.updateFirebaseConfig(null);
		this.props.updateLogin(null);
	};

	render() {
		console.log("authUser", this.props);
		return (
			<AuthUserContext.Consumer>
				{(authUser) =>
					authUser ? (
						this.props.history.push(ROUTES.DEFAULT)
					) : (
						<Auth
							onSubmit={this.signIn}
							loadStatus={this.state.loadStatus}
							onReturn={this.signOut}
						/>
					)
				}
			</AuthUserContext.Consumer>
		);
	}
}

const AuthNext = compose(withFirebase, withRouter)(AuthContainer);

export default connect(null, { updateFirebaseConfig, updateLogin })(AuthNext);
